/**
 * Service d'administration
 * Gère les opérations réservées aux administrateurs
 */

import { supabase } from '../supabaseClient';

export interface DeleteUserResult {
  success: boolean;
  user_id?: string;
  user_email?: string;
  message?: string;
  error?: string;
  deleted_counts?: Record<string, number>;
}

/**
 * Supprime un utilisateur et toutes ses données (SuiviFinance + autres apps)
 * Réservé aux administrateurs
 */
export const deleteUser = async (
  userId: string,
): Promise<{ data: DeleteUserResult | null; error: unknown }> => {
  try {
    const { data, error } = await supabase.rpc('admin_delete_user', {
      p_user_id: userId,
    });

    if (error) {
      console.error('[AdminService] Erreur lors de la suppression:', error);
      return { data: null, error };
    }

    const result = data as DeleteUserResult;
    if (result && result.success === false) {
      return {
        data: result,
        error: result.error || 'Échec de la suppression',
      };
    }

    return { data: result, error: null };
  } catch (error) {
    console.error('[AdminService] Exception lors de la suppression:', error);
    return { data: null, error };
  }
};
